<template>
  <b-modal
      :ref="name"
      :title="title"
      :cancel-title="$t('btn.close')"
      ok-only
      size="md"
      @close="close"
      @ok="close"
  >
    <template #modal-header>
      <div class="w-100">
        <h4 class="float-left">{{ $t('modal.title.edit_entry') }}</h4>
      </div>
    </template>
    <b-form>

      <b-form-group id="input-group-2" :label="$t('form.label.enter_label')" label-for="input-2">
        <b-form-input
            id="input-2"
            v-model="form.label"
            :placeholder="$t('form.placeholder.enter_label')"
            trim
            @keypress="isRestricted($event)"
            required
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-3" :label="$t('form.label.enter_order')" label-for="input-3">
        <b-form-input
            id="input-3"
            type="number"
            v-model="form.entryOrder"
            placeholder=""
            required
        ></b-form-input>
      </b-form-group>

      <b-form-checkbox
          id="checkbox-1"
          v-model="form.isActive"
          name="checkbox-1"
          :value="true"
          unchecked-value="not_accepted"
      >
        {{ $t('checkbox.is_active') }}
      </b-form-checkbox>

    </b-form>
    <template #modal-footer>
      <div class="w-100">
        <div class="buttons float-right">
          <b-button type="button" variant="secondary" class="mr-2" @click="close">{{ $t('btn.cancel') }}</b-button>
          <b-button variant="primary"  :disabled="busy" @click="submit">
            <div v-if="busy">
              <b-spinner small type="grow"></b-spinner>
              {{ $t('btn.state.saving') }}
            </div>
            <div v-else>
              {{ $t('btn.save') }}
            </div>
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>

</template>

<script>

import axios from "axios";

export default {
  props: {},
  data() {
    return {
      name: 'default-modal',
      title: '',
      busy: false,
      entry: null,
      form: {
        label: null,
        entryOrder: 69,
        entryKey: null,
        isActive: true
      },
    }
  },

  mounted: function () {
    console.log(this.form);
    this.$refs[this.name].show();
  },
  methods: {
    isRestricted: function (e) {
      e = (e) ? e : window.event;
      let charCode = (e.which) ? e.which : e.keyCode;
      // Space not allowed
      if (charCode === 32) {
        e.preventDefault();
      } else {
        return true;
      }
    },
    close() {
      this.$refs[this.name].hide();
    },
    submit() {
      const _this = this;
      this.busy = true;
      axios.put(`/api/dictionary/${this.$route.params.entry}/entry/${this.form.entryKey}`,
          {
            label: this.form.label,
            entryOrder: parseInt(this.form.entryOrder),
            'isActive': this.form.isActive ? true : false
          }).then(
          () => {
            _this.busy = false;
            _this.close();
            _this.$parent.$emit('refresh-dict');
          }
      )
    }
  }

}

</script>
